import { render, staticRenderFns } from "./UiUpload.vue?vue&type=template&id=5e917709&lang=pug&"
import script from "./UiUpload.vue?vue&type=script&lang=js&"
export * from "./UiUpload.vue?vue&type=script&lang=js&"
import style0 from "./UiUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports